<section>
  <div id="slider">
    <div id="headerSlider" class="carousel slide" data-ride="carousel">
      <!-- <ol class="carousel-indicators">
          <li data-target="#headerSlider" data-slide-to="0" class="active"></li>
  
        </ol> -->
      <div class="carousel-inner">
        <div class="carousel-item">
          <img src="../assets/images/banner1.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <div class="banner-text">
              <!-- <h4 class="">Our Three Pillars</h4> -->
              <!-- <h5>STRIDE &middot; STRIVE &middot; SOAR</h5> -->
              <h2>Blogs</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="team">
  <div class="container">
    <h1 class="heading text-center">ALL BLOGS</h1>
    <div class="row">
      <ng-container *ngFor="let blog of blogs">
        <div class="col-md-6 col-lg-4">
          <app-blog-item [blogDetail]="blog"></app-blog-item>
        </div>
      </ng-container>
    </div>
  </div>
</section>
